<script>
    import PreviewComponent from "./PreviewComponent";
    import CopyrightComponent from "../../components/pagesbuilder/dynamic-components/CopyrightComponent";
    export default {
        mixins : [PreviewComponent,CopyrightComponent]
    }
</script>
